export const ASSISTE = "assiste"
export const AUTONOME = "autonome"